import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';
import { AccountingInfoOptionFields } from '@/interfaces/AccountingInfoOption';

export default class AccountingInfoAPI {
    /**
     * @param type
     */
    public static async getAll(type: string): Promise<AxiosResponse> {
        try {
            return await ApiController.get(ApiRoutes.accountingInfo.base(type)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async getById(type: string, id: string | number): Promise<AxiosResponse> {
        try {
            return await ApiController.get(ApiRoutes.accountingInfo.byId(type, id)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async create(type: string, data: AccountingInfoOptionFields): Promise<AxiosResponse> {
        const request = {
            data: {
                type: type,
                attributes: {
                    code: data.code,
                    description: data.description,
                },
            },
        };
        try {
            return await ApiController.post(ApiRoutes.accountingInfo.base(type), request) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async update(type: string, id: string | number, data: AccountingInfoOptionFields): Promise<AxiosResponse> {
        const request = {
            data: {
                id: id.toString(),
                type: type,
                attributes: {
                    code: data.code,
                    description: data.description,
                },
            },
        };
        try {
            return await ApiController.patch(ApiRoutes.accountingInfo.byId(type, id), request) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async delete(type: string, id: string | number): Promise<AxiosResponse> {
        try {
            return await ApiController.delete(ApiRoutes.accountingInfo.byId(type, id)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }
}